import { render, staticRenderFns } from "./WelcomeBackBox.vue?vue&type=template&id=54cdc544&"
import script from "./WelcomeBackBox.vue?vue&type=script&lang=js&"
export * from "./WelcomeBackBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports